import { render } from "./MemoryOverview.vue?vue&type=template&id=3db0fd3d"
import script from "./MemoryOverview.vue?vue&type=script&lang=js"
export * from "./MemoryOverview.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__